module.exports = __webpack_public_path__ + "static/media/dummyImage.ae68a6da.png";